// extracted by mini-css-extract-plugin
export var adCard = "_ph-8";
export var adCardBorder = "_ph-5";
export var arbiterButtonIcon = "_ph-p";
export var buttonIcon = "_ph-o";
export var container = "_ph-e";
export var copyButton = "_ph-m";
export var darkGrey = "_ph-u";
export var deliveryDate = "_ph-2";
export var divider = "_ph-n";
export var editModeWrapper = "_ph-7";
export var empty = "_ph-a";
export var errorIcon = "_ph-d";
export var filledCircle = "_ph-4";
export var fulfillmentFooter = "_ph-j";
export var grey = "_ph-s";
export var header = "_ph-i";
export var headerWrapper = "_ph-h";
export var highlighted = "_ph-6";
export var historyEntry = "_ph-3";
export var mobileColumn = "_ph-v";
export var mobileColumnReverse = "_ph-w";
export var orderDetailsContainer = "_ph-g";
export var orderMetadata = "_ph-l";
export var orderMetadataWrapper = "_ph-k";
export var packagesContainer = "_ph-b";
export var product = "_ph-y";
export var productImage = "_ph-z";
export var productInfo = "_ph-x";
export var productTitle = "_ph-10";
export var strikethrough = "_ph-t";
export var tinyText = "_ph-r";
export var title = "_ph-9";
export var trackerCard = "_ph-1";
export var trackerCardWrapper = "_ph-0";
export var trackingContainer = "_ph-f";
export var trackingTitle = "_ph-c";
export var xTinyText = "_ph-q";